module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "houseMIBReport"
  }, [_vm._v("\n    ====================》这是houseMIBReport页\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7db465b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/houseMIBReport.vue
// module id = 1180
// module chunks = 1